import { UserRole } from 'types/shared';
import { z } from 'zod';

const userResponseSchemas = {
  fetchMe: z.object({
    success: z.boolean(),
    message: z.string(),
    user: z.object({
      id: z.number(),
      firstname: z.string(),
      lastname: z.string(),
      invitedBy: z.number(),
      permissions: z.string(),
      companyname: z.string(),
      password_updated_on: z.string(),
      profilepicture: z.string(),
      phone: z.string(),
      email: z.string().email(),
      countryCode: z.string(),
      is2FAEnabled: z.number(),
      status: z.number(),
      emailalerts: z.number(),
      secondaryemail: z.string(),
      addressline1: z.string(),
      addressline2: z.string(),
      city: z.string(),
      state: z.string(),
      zipcode: z.string(),
      autorecharge: z.number(),
      minbalance: z.number(),
      rechargeamount: z.number(),
      showApiKey: z.number(),
      consumeOfferAPI: z.number(),
      availablebalance: z.number(),
      role: z.nativeEnum(UserRole),
      isIREnabled: z.number(),
      isILDEnabled: z.number(),
      ma_id: z.string(),
      nonactivesimcount: z.number(),
      monthlyprice: z.nullable(z.number()),
      lobId: z.number(),
      url: z.nullable(z.string().url()),
      brandName: z.string(),
      deviceCoverageForSpr: z.number(),
      deviceCoverageForFixed: z.number(),
      paymentmethod: z.nullable(z.string()),
      documents: z.array(
        z.object({
          id: z.number(),
          userId: z.number(),
          fileurl: z.string().url(),
          filename: z.string(),
          createdAt: z.string(),
          type: z.string(),
          exportType: z.nullable(z.string()),
        })
      ),
      remianingPasswordExpiryDays: z.number().optional(),
      scope: z.string().optional(),
    }),
    reason: z.string(),
    resetToken: z.string(),
  }),
  impersonateUser: z.object({
    success: z.boolean(),
    message: z.string(),
    token: z.string(),
  }),
  fetchInviteUserDetail: z.object({
    success: z.boolean(),
    message: z.string(),
    data: z.object({
      id: z.number(),
      email: z.string(),
      firstname: z.string(),
      lastname: z.string(),
      companyname: z.string(),
      phone: z.string(),
    }),
  }),
  updateProfile: z.object({
    success: z.boolean(),
    data: z.object({
      message: z.string(),
    }),
  }),
} as const;

export default userResponseSchemas;
